import React, { useState } from "react";
import classNames from "classnames";
import Slider from "react-slider";
import styles from "./Controls.scss";
import { Icon } from "../../../graphic/Icon";

export const Controls = ({
    visible,
    onPlay,
    onPause,
    onMute,
    setFullscreen,
    isMuted,
    isPlaying,
    seekBarValue,
    setSeekBarValue,
    bufferLength
}) => {
    const [touched, setTouched] = useState(false);

    const performAction = (callback) => {
        setTouched(true);
        callback();
    };

    return (
        <div
            className={classNames(styles.controls, {
                [styles.visible]: visible
            })}
        >
            <div className={styles.buttonPane}>
                {/* Remember sound tip */}
                <div
                    className={classNames(styles.soundTip, {
                        [styles.showTip]: isPlaying && isMuted && !touched
                    })}
                >
                    <div className={styles.tipWrapper}>Husk lyd</div>
                </div>

                {/* Play / Pause */}
                {!isPlaying ? (
                    <button onClick={() => performAction(onPlay)}>
                        <Icon name="play" />
                    </button>
                ) : (
                    <button onClick={() => performAction(onPause)}>
                        <Icon name="pause" />
                    </button>
                )}

                {/* Mute / Unmute */}
                {isMuted ? (
                    <button onClick={() => performAction(() => onMute(false))}>
                        <Icon name="mute" />
                    </button>
                ) : (
                    <button onClick={() => performAction(() => onMute(true))}>
                        <Icon name="unmute" />
                    </button>
                )}

                {/* Fullscreen */}
                <button onClick={setFullscreen}>
                    <Icon name="maximize" />
                </button>
            </div>

            <div className={styles.rangeSlider}>
                <div className={styles.sliderWrapper}>
                    <Slider
                        value={isNaN(seekBarValue) ? 0 : seekBarValue}
                        onChange={(val) => performAction(() => setSeekBarValue(val))}
                        className={styles.slider}
                        trackClassName={styles.track}
                        thumbClassName={styles.thumb}
                        thumbActiveClassName={styles.active}
                    />

                    {/* Buffer progress */}
                    {bufferLength ? (
                        <div
                            className={styles.progress}
                            style={{
                                width: `${bufferLength}%`
                            }}
                        />
                    ) : null}
                </div>
            </div>
        </div>
    );
};
